export default __webpack_public_path__ + "static/media/11.f5b4ed1b.png";